import { Component, ChangeDetectionStrategy } from '@angular/core';

import { SnTag } from '@lib/api/entities';
import { snListStagger, snFadeIn, snFadeOut } from '@lib/common/animations';
import { SnTableBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-tag-table',
  templateUrl: './tag-table.component.html',
  styleUrls: ['./tag-table.component.scss'],
  animations: [snListStagger, snFadeIn, snFadeOut],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagTableComponent extends SnTableBaseComponent<SnTag> {
  constructor() {
    super();
  }

  public trackBy(index: number, item: SnTag): string {
    return item.id;
  }
}
